module.exports = __webpack_public_path__ + "static/img/20016 (2).f0efd41.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20016 (2).webp
// module id = 1OaP
// module chunks = 14